<template>
    <div class="settings__item data-card block">
        <div class="data-card__head">
            <div class="data-card__title">
                <span class="data-card__label">E-mail<sup>*</sup>:</span>
                <span class="data-card__value">{{user.Email}}</span>
                <div class="txt-input__required txt-input__required--error error-block" v-if="isValidateErrors">{{serverErrors}}</div>
            </div>
            <div class="data-card__link">
                <span v-if="isemailverified === 'false' && user.Email"
                      v-on:click="verifyEmail" class="data-card__confirmation link link--present status-error link__text" style="color: red;margin-right: 20px;cursor: pointer;">Подтвердить</span>
                <span v-if="isemailverified === 'true' && user.Email"
                      class="data-card__confirmation link link--present status-error link__text" style="color: green;margin-right: 20px;">Подтвержден</span>
                <a v-on:click="isServerVerify=false; isValidateErrors=false; prefix=''; serverMessage=[]" href="#dataCard_2" class="link link--present" data-toggle="collapse"><span class="link__text">Изменить</span></a>
            </div>
        </div>
        <div id="dataCard_2" v-if="!isServerVerify" class="data-card__form accordion-body collapse">
            <div class="data-card__inner accordion-body__inner">
                <div class="b-form-sm">
                    <div class="b-form-sm__body">
                        <div class="b-form-sm__item">
                            <label class="txt-input">
                                <div class="txt-input__input">
                                    <input class="txt-input__field input"
                                           :class="!$v.newEmail.emailType ? 'is-error' : ''"
                                           type="text"
                                           :placeholder="user.Email ? user.Email : 'E-mail'"
                                           v-model="newEmail">
                                </div>

                            </label>
                        </div>
                        <div class="b-form-sm__item" style="padding-right:0px;">
                            <a class="button button--th-second"
                               :class="(!$v.newEmail.emailType || isEqualUserData) ? 'disabled' : ''"
                               v-on:click="verifyEmail">Получить код</a>
                            <a v-on:click="deleteEmail" class="button button--th-error js-profile-remove-button" v-if="user.Email">Удалить<br>контакт</a>
                            <a href="#dataCard_2" @click="newEmail=user.Email; isValidateErrors=false" class="button button--th-link" data-toggle="collapse" style="width:75px;">Отменить</a>
                        </div>
                    </div>
                    <div class="txt-input__required txt-input__required--error error-block">{{validateEmailTypeText}}</div>
                    <div class="txt-input__required" style="background-color: white" :class="isValidateErrors ? 'error-block' : 'validated-block'">{{serverResponseText}}</div>
                </div>
            </div>
        </div>
        <modal-email v-if="isServerVerify" :prefix="prefix" :email="newEmail" :currentUserName="user.UserName" @close="isServerVerify = false" @update="updateUserEmail" @refresh="verifyEmail"></modal-email>
    </div>
</template>

<script>

    import ModalEmailVerify from './ModalEmailVerify.vue';

    const { required } = window.validators
    const { validationMixin } = window.vuelidate

    export default {
        mixins: [validationMixin],
        props: ['user', 'isemailverified', 'isphonenumberverified'],
        components: {
            'modal-email': ModalEmailVerify
        },
        data: function () {
            return {
                newEmail: this.user.Email,
                isServerVerify: false,
                isValidateErrors: false,
                serverMessage: [],
                serverErrors: '',
                serverResponse: '',
                prefix: ''
            }
        },
        created: function () {
        },
        computed: {
            validateEmailTypeText: function () {
                return !this.$v.newEmail.emailType || this.newEmail == '' ? 'Неверно указан адрес Email' : ' ';
            },
            serverResponseText: function () {
                return this.serverMessage ? this.serverMessage[0] : '';
            },
            isEqualUserData: function () {
                return this.user.Email == this.newEmail;
            }
        },
        watch: {
            newEmail: function () {
                if (this.newEmail.length >= 1) {
                    this.serverMessage = [];
                    this.isServerVerify = false;
                }

                this.newEmail = this.newEmail.trim();
            },
            isValidateErrors: function (isValidateErrors) {
                if (!isValidateErrors) {
                    this.serverMessage = [];
                }
            },
            serverResponse: function (serverResponse) {
                this.serverMessage = serverResponse.message;

                if (serverResponse.isSuccess) {
                    this.isValidateErrors = false;
                    this.isServerVerify = true;
                } else {
                    this.isValidateErrors = true;
                    this.isServerVerify = false;
                }
            }
        },
        validations: {
            newEmail: {
                required: required,
                emailType: function (value) {
					return value.match('\\w+([-+.]\\w+)*@\\w+([-.]\\w+)*\\.\\w+([-.]\\w+)*') ? true : false;
                }
            }
        },
        methods: {
            deleteEmail: function () {
                if (this.user.Email && this.user.PhoneNumber) {
                    if (this.isemailverified == 'false') {
                        var self = this;
                        this.isValidateErrors = false;

                        axios.post('/Profiles/ChangeEmail', {
                            CurrentUserName: self.user.UserName,
                            Email: '',
                            VerificationCode: '7777'
                        })
                            .then(function (response) {
                                self.serverMessage = response.data.message;
                                self.user.Email = '';
                                self.newEmail = '';
                            })
                            .catch(function (error) {
                                console.log(error);
                                self.isValidateErrors = true;
                                self.serverMessage = ['Удаление email невозможно, попробуйте позже'];
                            });
                        self.isServerVerify = false;
                    }
                    else {
                        this.newEmail = this.user.Email;
                        this.prefix = '*';
                        this.verifyEmail();
                    }
                }
                else {
                    this.isValidateErrors = true;
                    this.serverMessage = ['Данный контакт используется при авторизации, произведите замену на другой контакт либо удалите данный профиль целиком.'];
                }
            },
            verifyEmail: function () {
                var self = this;
                this.isValidateErrors = false;

                axios.post('/Profiles/VerifyEmail', {
                    CurrentUserName: self.user.UserName,
                    Email: self.prefix + self.newEmail.trim()
                })
                    .then(function (response) {
                        self.isServerVerify = response.data.isSuccess;
                        if (!self.isServerVerify) {
                            self.serverErrors = response.data.message.join('');
                            self.isValidateErrors = true;
                        }
                    })
                    .catch(function (error) {
                        self.isValidateErrors = true;
                        self.isServerVerify = false;
                        self.serverMessage = ['Изменение email невозможно, попробуйте позже']
                    });
            },
            updateUserEmail: function (email) {
                this.$emit('update', email);
                this.$emit('verified');
                this.isValidateErrors = false;
                this.serverMessage = ['Email успешно изменен']
            }
        }
    }

</script>


// WEBPACK FOOTER //
// Scripts/app/profiles/components/ChangeEmail.vue